import { type UseQueryResult, useQuery } from 'react-query';
import { TablePreferencesService } from '../../services/wealthlane-award-services';

const useGetTablePreferences = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableName: string
): UseQueryResult<string[] | undefined, unknown> => {
  const tablePreferances = useQuery(['getTablePreferences', tableName], async () => {
    return await handleRequest(
      TablePreferencesService.getApiAwardApiAppTablePreferencesTablePreferences(tableName)
    );
  });

  return tablePreferances;
};

export default useGetTablePreferences;
